
export const TaskTypes = {
    "UNDOCK_ALL" : "UNDOCK_ALL",
    "DOCK_ALL" : "DOCK_ALL",
    "REPLACE" : "REPLACE"
}
export const GOOGLE_DRIVE_FOLDER_URL = "https://drive.google.com/drive/folders/0AL39lKSYPcrkUk9PVA";